import { Component, OnInit, HostListener } from '@angular/core';
import { CmsmoduleService } from '../../manage/cmsmodule/service/cmsmodule.service';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { BannerService } from '../../services/banner.service';
//import { OwlOptions } from 'ngx-owl-carousel-o';
import { environment } from "./../../../environments/environment";
import { CustomValidators } from 'ng2-validation';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
//import { ReferAFriendService } from '../service/referAFriendService.service';
import { MenuItem } from 'primeng/api';
@Component({
  selector: 'app-termsncondition',
  templateUrl: './termsncondition.component.html',
  styleUrls: ['./termsncondition.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class TermsnconditionComponent implements OnInit {

  isScrolled = false;
  activeSectionId = 'FindPartner';

  availableClasses: string[] = ["body-dark", "body-white", "colorful"];
  currentClassIdx: number = 0;

  bodyClass: string
  items: MenuItem[];
  public loading: boolean;
  public cmsContent;
  public cmsContentData;
  public errorMessage: string;
  public bannerList: any[];
  public totalRecords = 0;
  public bannerImageList: any[] = [];
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  @HostListener('window:scroll', [])
  onScroll(): void {
    this.isScrolled = window.scrollY > 320;
  }

  constructor(private cmsmoduleService: CmsmoduleService, private bannerService: BannerService,) {
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
  }

  ngOnInit(): void {
    this.getCmsContent();
    // this.getBanner();
    // this.items=[
    //   { routerLink:"/",label:"Home" },
    //   { label:"Terms and Condition" }
    // ]
  }
  /*Body-class start*/
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;

    if (bodyElement) {


      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];

      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);

      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  /*Body-class end*/

  preprocessHtml(html: string): string {
    if (!html) return '';
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const children = Array.from(doc.body.children);

      let newHtml = '';
      let currentGroupHtml = '';
      let currentHeadingHtml = '';
      let currentHeadingId = '';

      const flushGroup = () => {
        if (currentHeadingHtml) {
          const idAttribute = currentHeadingId ? ` id="${currentHeadingId}"` : '';
          newHtml += `<h3 class="sub-title"${idAttribute}>${currentHeadingHtml}</h3>`;
        }
        if (currentGroupHtml.trim()) {
          newHtml += `<div class="list-alpha termsandconditionsection">${currentGroupHtml}</div>`;
        }
        currentGroupHtml = '';
        currentHeadingHtml = '';
        currentHeadingId = '';
      };

      children.forEach((child) => {
        const tagName = child.tagName.toLowerCase();
        const textContent = child.textContent || '';
        const innerHtml = child.innerHTML.trim();

        if (innerHtml === '<br>' || innerHtml === '' || textContent.trim() === '') {
          return;
        }

        if (tagName === 'h1') {
          flushGroup();
          currentHeadingHtml = this.formatTermsHeading(textContent);
          currentHeadingId = this.getTermsSectionId(textContent);
          return;
        }

        const isSubItem = /^[i|v|x]+\.\s+/i.test(textContent.trim());
        if (isSubItem) {
          child.classList.add('sub-list-item');
        }
        currentGroupHtml += child.outerHTML;
      });

      flushGroup();
      return newHtml || html;
    } catch (e) {
      console.error('Error preprocessing terms CMS HTML:', e);
      return html;
    }
  }

  formatTermsHeading(value: string): string {
    const formatted = value
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
    return formatted.replace(/\bTpl\b/g, 'TPL');
  }

  getTermsSectionId(value: string): string {
    const text = value.trim().toUpperCase();
    switch (text) {
      case 'FIND A PARTNER':
        return 'FindPartner';
      case 'TPL ACADEMY':
        return 'TPLAcademy';
      case 'TPL TOURNAMENT':
      case 'TPL TOURNAMENTS':
        return 'TPLTournament';
      case 'TPL STORE':
        return 'TPLStore';
      case 'TPL CONTEST':
        return 'TPLContest';
      default:
        return '';
    }
  }

  assignTermsSectionIds() {
    const headings = document.querySelectorAll('.section-contain h1, .section-contain h2, .section-contain h3, .section-contain .sub-title');

    headings.forEach((h: any) => {
      const sectionId = this.getTermsSectionId(h.innerText || h.textContent || '');
      if (sectionId) {
        h.id = sectionId;
      }
    });
  }

  getCmsContent() {
    var query = "?filterByDisable=false&filterByStatus=true&filterBySlug=termsandcondition";
    this.cmsmoduleService.getContentDetails(query).subscribe(
      data => {
        this.loading = false;
        this.cmsContent = data.data.items[0];
        if (this.cmsContent != undefined) {
          this.cmsContentData = this.preprocessHtml(this.cmsContent['cmsDescription']);

          setTimeout(() => {
            this.assignTermsSectionIds();
          });

        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  scrollToSection(id: string, event?: Event) {
    if (event) {
      event.preventDefault();
    }
    this.activeSectionId = id;
    this.assignTermsSectionIds();
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }



}
